import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@trillion/ui/theme/theme-provider";
import { Toaster } from "@trillion/ui/components/ui/sonner";
import { TooltipProvider } from "@trillion/ui/components/ui/tooltip";

export function RootLayout() {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <div className="antialiased">
          <Outlet />
        </div>
      </TooltipProvider>
      <Toaster />
    </ThemeProvider>
  );
}
